import React, {useEffect, useState} from 'react';
import {Button, Col, Row, Spinner} from 'react-bootstrap';
import Dropdown from "../../../../primer/Dropdown";
import Input from '../../../../common/Input';
import {
    checkPermission,
    getCountryOptions, getCurrentUser,
    getDefaultOptionByValue,
    getDOYOptions, getGeneratedMaskCodeCLient,
    getMainInstallation,
    getOptionsByData, getSexOptions,
    getVatCategoryAbroadOptions,
    getVatCategoryOptions, isEmpty,
    isValidEmail
} from '../../../../../_helpers/commonFunctions';
import {useSelector} from "react-redux";
import {setSaveEditClient} from "../../../../../_reducers/activitySlice";
import {
    setClientMovementsSearchByBalance,
    setEditClient,
    setEditContactPoint,
    setEditBankInfo,
    resetEditBankInfo,
} from '../../../../../_reducers/DataPanel/Clients/clientSlice';
import {setActiveModal, setNewCompany} from "../../../../../_reducers/companySlice";
import getMyData from '../../../../../_helpers/sharedmydata';
import TextArea from '../../../../common/TextArea';
import EditableTable from '../../../../primer/Editable-Table';
import {
    findObjectFromArrayOfObjects,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from '../../../../../_helpers/helperFunctions';
import {toast} from 'react-toastify';
import Checkbox from '../../../../common/CheckBox';
import {
    fetchClientsSettings,
    fetchInitialClients,
} from '../../../../../_apis/api';
import axios from "axios";
import AnathetousesModal from "../../../../primer/POPUP-COMPONENTS/AnathetousesModal";
import LogTable from "../../../../primer/LogTable";
import DateBox from "../../../../primer/DateBox";
import moment from "moment/moment";
import {fetchPatientDetails} from "../clientHelpers";
import {setAutoPatientHistory} from "../../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {extendedBankOptions} from "../../../../../_data/dummy_banks";
import {openClientMovementsReport, openTabByType} from "../../../../../_helpers/tabOpeners";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import {useTranslation} from "../../../../../hooks/useTranslation";

const EditClientGeneral = ({tabKey}) => {
    const {t, locale} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const COMPANY_DATA = useSelector(state => state.COMPANY_DATA);
    const company = COMPANY_DATA.company;
    const clientCategories = getObjectFromArrayOfObjects(CLIENTS_DATA.clientsSettings.categories, 'active', 'isActive');
    const [clientCategoriesOption, setClientCategoriesOption] = useState([]);
    const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});
    let vatCategoryList = (editClient.categoryName === "Client within E.U." || editClient.categoryName === "Client outside E.U." || (editClient.categoryName === "Retail" && editClient.country !== "GR")) ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const currentUser = getCurrentUser();
    const isAdmin = currentUser?.userType === "Admin";
    const isPrimerConstructor = permissionsData?.some((el) => el.permissionName === "custom-primerConstructor");
    const isCompanyCreator = permissionsData?.some((el) => el.permissionName === "custom-companyCreator");
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);

    const availableTags = CLIENTS_DATA.clientsSettings?.tags || [];
    const tagOptions = availableTags.map((o) => ({value: o, label: o}));

    const companyHasPrescription = useSelector((state) => state.PRESCRIPTION.companyHasPrescription);

    const [incrKey, setIncrKey] = useState(0);
    const [bankInfoIncrKey, setBankInfoIncrKey] = useState(0);
    const [loadingTaxis, setLoadingTaxis] = useState(false);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editClient.contactPoints])

    useEffect(() => {
        setBankInfoIncrKey(bankInfoIncrKey + 1);
    }, [editClient?.bankInfo])

    useEffect(() => {
        let retailGroup = ["1", "8"];
        if (retailGroup.includes(editClient.category)) {
            setClientCategoriesOption(getOptionsByData(clientCategories.filter((el) => retailGroup.includes(el._id)), '_id', 'category'));
        } else {
            setClientCategoriesOption(getOptionsByData(clientCategories.filter((el) => !retailGroup.includes(el._id)), '_id', 'category'));
        }
    }, [editClient.category])

    const isValidCustomVat = (value) => {
        let error;
        if (+value > 100) {
            error = 'Can not be greater than 100.';
        }
        return error;
    }
    const clientContactPointsColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.contactName'),
            field: "name",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.mobilePhone'),
            field: "mobile",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.landLine'),
            field: "landline",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.otherPhone'),
            field: "otherPhone",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.email'),
            field: "email",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.contactNotes'),
            field: "contactNotes",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.acceptNotifications'),
            field: "acceptsNotifications",
            editable: true,
            inputType: {
                type: "checkbox",
            },
        },
    ]

    const clientBankInfoColumns = [
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankFriendlyName'),
            field: "bankFriendlyName",
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankInstitute'),
            field: "bankInstitute",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                options: extendedBankOptions,
            }
        },
        {
            name: "IBAN",
            field: "iban",
            editable: true,
            width: "50%",
            inputType: {
                type: 'text',
            }
        },
    ]

    useEffect(() => {
        // It will use for validate client name
        dispatch(fetchInitialClients({
            company: company.id,
            year: company.year,
            isActive: 'active'
        }));

        dispatch(fetchClientsSettings({
            company: company.id,
            year: company.year.toString(),
            isActive: "active"
        }))

    }, []);

    useEffect(() => {
        setTableColumns(clientContactPointsColumns.slice());
        setBankInfoTableColumns(clientBankInfoColumns.slice());
    }, [locale])

    const [tableColumns, setTableColumns] = useState(clientContactPointsColumns.slice())
    const [bankInfoTableColumns, setBankInfoTableColumns] = useState(clientBankInfoColumns.slice())
    const [showErrors, setShowErrors] = useState(false)
    // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Select Greece, Accept only Greece, show only Greece
    let allCountries = getCountryOptions('all');
    let countriesList = getCountryOptions("greece");
    if (editClient.categoryName === "Client within E.U.") {
        // Update country list for inside EU.
        // Client inside E.U., show only countries within E.U. except Greece
        countriesList = getCountryOptions("insideEU");
    } else if (editClient.categoryName === "Client outside E.U.") {
        // Update country list for outside EU
        // outside E.U., show only countries outside E.U.
        countriesList = getCountryOptions("outsideEU");
    } else if (editClient.categoryName === "Retail" || editClient.categoryName === "Patient") {
        countriesList = getCountryOptions('all');
    } else {
        // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:
        // Select Greece, Accept only Greece, show only Greece
        countriesList = getCountryOptions("greece");
    }
    let disabledFields = false;
    if (editClient.category === undefined || editClient.category === '') {
        disabledFields = true;
    }
    const apiURL2 = process.env.REACT_APP_API_URL2;

    const fetchViesDetails = async (vat, country) => {
        let jsonData = {
            vatNumber: vat,
            country: country
        }
        if (vat === "" || vat === undefined) {
            toast.error("Please input a vat Number to check.");
        } else if (country === "" || country === undefined) {
            toast.error("Please select a country for VIES check.");
        } else {
            console.log(jsonData);
            const abort = axios.CancelToken.source();
            const timer = setTimeout(() => abort.cancel(`timeout`), 10000);
            setLoadingTaxis(true);
            await axios.post(apiURL2 + `/client/fetch-vies-details/`, JSON.stringify(jsonData), {headers: {'Content-Type': 'application/json'}})
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

                        clearTimeout(timer)
                        let companyDetails = res.data.data;
                        if (companyDetails.valid === true) {
                            let newClient = Object.assign({}, editClient);
                            newClient.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
                            let address = companyDetails?.address.split(",");
                            newClient.postalCode = address[2] !== undefined ? address[2].split(" ")[1] : "";
                            newClient.address = address[1] !== undefined ? address[1] : "";
                            newClient.city = address[2] !== undefined ? address[2].split(" ")[2] : "";
                            newClient.vatCategory = 'Zero VAT';
                            newClient.vatReason = "14";
                            let updatedContactPoints = editClient.contactPoints.slice();
                            let newContacts = {
                                name: newClient.name,
                                email: newClient.email,
                                mobile: newClient.phone,
                                acceptsNotifications: "active"
                            };
                            updatedContactPoints["0"] = {
                                ...updatedContactPoints["0"],
                                ...newContacts,
                            };
                            let defaultInstallation = [
                                {
                                    id: 0,
                                    no: 0,
                                    type: getMainInstallation()?.value,
                                    address: newClient.address,
                                    DOY: newClient.DOY,
                                    city: newClient.city,
                                    county: newClient.county,
                                    vatCategory: newClient.vatCategory,
                                    vatReason: newClient.vatReason,
                                    customVat: newClient.customVat,
                                    postalCode: newClient.postalCode
                                },
                            ];
                            dispatch(setEditClient({
                                ...newClient,
                                contactPoints: updatedContactPoints,
                                installations: defaultInstallation
                            }));
                            toast.success(res.data.message);
                        } else {
                            toast.error("VAT Number with this country was not found on VIES");
                        }
                    } else {
                        console.log(res)
                        toast.error(res.data.message);
                    }
                    setLoadingTaxis(false);
                })
                .catch((error) => {
                    setLoadingTaxis(false);
                    console.log(error);
                    if (error.response?.status === 400) {
                        alert({
                            message: error.response.data?.Error ? error.response.data?.Error : error?.message === "timeout" ? "Timeout. Please try again later!" : error.code,
                            type: 'warning',
                        })
                    }
                });
        }
    }

    const fetchTaxisNetDetails = async (data) => {
        let jsonData = {
            vatNumber: data,
            onlyAADE: "true"
        }
        if (data === "" || data === undefined) {
            return toast.error("Παρακαλώ εισάγετε ΑΦΜ για έλεγχο.");
        }
        setLoadingTaxis(true);
        const abort = axios.CancelToken.source();
        const timer = setTimeout(
            () => abort.cancel(`timeout`),
            10000
        )
        await axios.post(apiURL2 + `/client/fetch-vat-details/`, JSON.stringify(jsonData), {headers: {'Content-Type': 'application/json'}})
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

                    clearTimeout(timer)
                    let companyDetails = res.data.data;
                    let cloneClient = Object.assign({}, editClient);
                    cloneClient.name = companyDetails?.name !== undefined ? companyDetails?.name : "";
                    cloneClient.smallName = companyDetails?.smallName !== undefined ? companyDetails?.smallName : "";
                    cloneClient.activity = companyDetails?.activity !== undefined ? companyDetails?.activity : "";
                    cloneClient.postalCode = companyDetails?.tk !== undefined ? companyDetails?.tk : "";
                    cloneClient.address = companyDetails?.address !== undefined ? companyDetails?.address : "";
                    cloneClient.DOY = getDefaultOptionByValue(getDOYOptions(), Number(companyDetails?.doyCode), "value", "label", "value").value;
                    cloneClient.city = companyDetails?.city !== undefined ? companyDetails?.city : "";
                    if (companyDetails?.vatCategory === 'Y') {
                        cloneClient.vatCategory = 'Normal VAT';
                    }
                    let updatedContactPoints = cloneClient.contactPoints.slice();
                    let newContacts = {
                        name: cloneClient.name,
                        email: cloneClient.email,
                        mobile: cloneClient.phone,
                        acceptsNotifications: "active"
                    };
                    updatedContactPoints["0"] = {
                        ...updatedContactPoints["0"],
                        ...newContacts,
                    };
                    let defaultInstallation = [
                        {
                            id: 0,
                            no: 0,
                            type: getMainInstallation()?.value,
                            address: cloneClient.address,
                            DOY: cloneClient.DOY,
                            city: cloneClient.city,
                            county: cloneClient.county,
                            vatCategory: cloneClient.vatCategory,
                            vatReason: cloneClient.vatReason,
                            customVat: cloneClient.customVat,
                            postalCode: cloneClient.postalCode
                        },
                    ];
                    dispatch(setEditClient({
                        ...cloneClient,
                        contactPoints: updatedContactPoints,
                        installations: defaultInstallation
                    }));
                    if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setLoadingTaxis(false);
            })
            .catch((error) => {
                setLoadingTaxis(false);
                console.log(error);
                if (error.response?.status === 400) {
                    alert({
                        message: error.response.data?.Error ? error.response.data?.Error : error?.message === "timeout" ? "Timeout. Please try again later!" : error.code,
                        type: 'warning',
                    })
                }
            });
    }
    const handleOnChange = async (e, type = "default", ddname = '') => {
        setShowErrors(true);
        if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

        let name;
        let value;
        if (type === "dd") {
            name = ddname;
            value = e.value;
        } else if (type === "ac") {
            name = ddname;
            value = e.row.value;
        } else if (type === "datebox") {
            name = ddname;
            value = moment(e).isValid() ? moment(e).format("DD/MM/YYYY") : "";
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        // 9 numbers only
        if (name === "vatNumber" && editClient.categoryName !== "Client within E.U." && editClient.categoryName !== "Client outside E.U.") {
            //  value = +String(value).slice(0, 9);

            // Set Empty if zero
            if (value === 0) {
                //   value = "";
            }
        }
        if (name === 'customVat') {
            if (+value > 100) {
                toast.error('Can not be greater than 100.');
                value = "";
            }
            value = +parseFloat(value).toFixed(1);
            if (value === 0) {
                value = "";
            }
        }

        // Set settings data
        let cloneClient = Object.assign({}, editClient);
        let editClientData = {};
        if (name === 'category') {
            editClientData[name] = value;
            editClientData.categoryName = getLabelByValue(clientCategoriesOption, value, 'value');
            const selectedCategory = findObjectFromArrayOfObjects(clientCategories, value, '_id');
            if (selectedCategory) {
                editClientData.categoryMaskCodePrefix = selectedCategory.maskCodePrefix;
                editClientData.systemCode = getGeneratedMaskCodeCLient(selectedCategory._id, clientCategories, selectedCategory.maskCodePrefix); // New With Updated Prefix
                editClientData.accounting = selectedCategory.accounting ? selectedCategory.accounting : '';
                editClientData.bypassAccounting = selectedCategory.bypassAccounting ? selectedCategory.bypassAccounting : '';
            }
            // If Category: Retail: Add 999999999, do not validate VAT number. Field not mandatory
            if (editClientData.categoryName === 'Retail' || editClientData.categoryName === 'Patient') {
                editClientData.vatNumber = 999999999;
            } else {
                editClientData.vatNumber = "";
            }
            if (editClientData.categoryName === "Client within E.U.") {
                // Update country list for inside EU.
                // Client inside E.U., show only countries within E.U. except Greece
                countriesList = getCountryOptions("insideEU");
            } else if (editClientData.categoryName === "Client outside E.U.") {
                // Update country list for outside EU
                // outside E.U., show only countries outside E.U.
                countriesList = getCountryOptions("outsideEU");
            } else {
                // Retail, Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.:
                // Select Greece, Accept only Greece, show only Greece
                countriesList = getCountryOptions("greece");
            }
        } else {
            editClientData[name] = value;
        }
        vatCategoryList = (editClientData.categoryName === "Client within E.U." || editClientData.categoryName === "Client outside E.U." || (editClientData.categoryName === "Retail" && editClientData.country !== "GR")) ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
        let updatedContactPoints = cloneClient.contactPoints.slice();
        let newContacts = {
            name: cloneClient.name,
            email: cloneClient.email,
            mobile: cloneClient.phone,
            acceptsNotifications: "active"
        }
        if (e) {
            if (name === "name") {
                newContacts["name"] = value;
            } else if (name === "email") {
                newContacts["email"] = value;
            } else if (name === "phone") {
                newContacts["mobile"] = value;
            } else if (name === "category") {
                newContacts["mobile"] = "";
            }
        }
        updatedContactPoints["0"] = {
            ...updatedContactPoints["0"],
            ...newContacts,
        }
        cloneClient = {...cloneClient, ...editClientData}
        // Default Installation
        let defaultInstallation = [{
            id: 0,
            no: 0,
            type: getMainInstallation()?.value,
            address: cloneClient.address,
            DOY: cloneClient.DOY,
            city: cloneClient.city,
            county: cloneClient.county,
            vatCategory: cloneClient.vatCategory,
            vatReason: cloneClient.vatReason,
            customVat: cloneClient.customVat,
            postalCode: cloneClient.postalCode
        }]
        let updatedInstallations = cloneClient.installations.slice();
        updatedInstallations["0"] = {
            ...updatedInstallations["0"],
            ...defaultInstallation,
        };
        dispatch(setEditClient({
            ...cloneClient,
            contactPoints: updatedContactPoints,
            installations: updatedInstallations
        }));
    }

    const handleColumnShowHide = (field) => {
        let tempTc = tableColumns.slice();
        let object = getObjectFromArrayOfObjects(tempTc, field, 'field')
        const index = tempTc.findIndex((item) => field === item.field);
        if (object.length > 0) {
            tempTc[index].hiddenColumn = !object['0'].hiddenColumn;
            setTableColumns(tempTc);
        }
    }

    const parentMydataActions = {
        insert: (e, data) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }
            let tempContactPoint = Object.assign({}, CLIENTS_DATA.newContactPoint);
            if (e.key !== "Enter") {
                tempContactPoint[data.field] = data.value;
                dispatch(setEditContactPoint(tempContactPoint)); // Update redux
                if (data.value !== '') {
                    let updatedContactPoint = Object.assign({}, tempContactPoint);
                    let oldContactPoints = editClient.contactPoints;
                    updatedContactPoint.no = oldContactPoints.length + 1;
                    updatedContactPoint.id = oldContactPoints.length + 1;
                    dispatch(setEditClient({
                        ...editClient,
                        contactPoints: [...oldContactPoints, updatedContactPoint]
                    }));
                    dispatch(setEditContactPoint(CLIENTS_DATA.newContactPointInitialValue)); // Reset new category mydata
                }
            }
            if (e.key === "Enter" && data.value === "add") {
                let updatedContactPoint = Object.assign({}, tempContactPoint);
                let oldContactPoints = editClient.contactPoints;
                updatedContactPoint.no = oldContactPoints.length + 1;
                updatedContactPoint.id = oldContactPoints.length + 1;
                dispatch(setEditClient({
                    ...editClient,
                    contactPoints: [...oldContactPoints, updatedContactPoint]
                }));
                dispatch(setEditContactPoint(CLIENTS_DATA.newContactPointInitialValue)); // Reset new category mydata
            }
        },
        update: (data, id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }
            if (data.name && (data.name.length === 0)) {
                toast.error("Contact Name is mandatory field.");
            } else {
                setSaveEditClient(true);
                let contactPoints = editClient.contactPoints.slice();
                if (contactPoints.find(item => item.id === id) !== undefined) {
                    if (id === "0" && data?.acceptsNotifications) {
                        id = 1;
                    }
                    contactPoints[id - 1] = {...contactPoints[id - 1], ...data};
                    dispatch(setEditClient({...editClient, contactPoints: contactPoints})); // update data
                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }

            let contactPoints = editClient.contactPoints.slice();
            if (rowIndex !== 0 && contactPoints.length >= 2) {
                contactPoints.splice(rowIndex, 1);
                const updatedContactPoints = contactPoints.map((item, index) => ({
                    ...item,
                    no: index + 1,
                    id: index + 1,
                }));
                dispatch(setEditClient({...editClient, contactPoints: updatedContactPoints}));
            } else {
                toast.error('First row can not be deleted.');
            }
        }
    }

    const bankInfoTableActions = {
        insert: (e, data) => {
            let tempBankInfo = Object.assign({}, CLIENTS_DATA.editBankInfo);
            if (e.key !== "Enter") {
                tempBankInfo[data.field] = data.value;
                dispatch(setEditBankInfo(tempBankInfo));
                let oldBankInfo = editClient?.bankInfo || [];
                let updatedBankInfo = Object.assign({}, tempBankInfo);
                if (updatedBankInfo && updatedBankInfo.bankFriendlyName !== '' && updatedBankInfo.bankInstitute !== '' && updatedBankInfo.iban !== '') {
                    dispatch(setEditClient({
                        ...editClient,
                        bankInfo: [...oldBankInfo, updatedBankInfo]
                    }));
                    dispatch(resetEditBankInfo());
                    dispatch(setSaveEditClient(true));
                }
            } else {
                let updatedBankInfo = Object.assign({}, CLIENTS_DATA.newBankInfo);
                let oldBankInfo = editClient?.bankInfo || [];
                if (e.key === "Enter" || data.value === "add") {
                    if (updatedBankInfo && updatedBankInfo.bankFriendlyName !== '' && updatedBankInfo.bankInstitute !== '' && updatedBankInfo.iban !== '') {
                        dispatch(setEditClient({
                            ...editClient,
                            bankInfo: [...oldBankInfo, updatedBankInfo]
                        }));
                        dispatch(resetEditBankInfo());
                        dispatch(setSaveEditClient(true));
                    }
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }

            let bankInfo = editClient.bankInfo.slice();
            bankInfo[rowIndex] = {...bankInfo[rowIndex], ...data};
            dispatch(setEditClient({...editClient, bankInfo: bankInfo})); // update data
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }

            let bankInfo = editClient.bankInfo.slice();
            bankInfo.splice(rowIndex, 1);
            dispatch(setEditClient({...editClient, bankInfo: bankInfo}));
        }
    }

    const [loadingPeppolDetails, setLoadingPeppolDetails] = useState(false);
    const handleGetCompanyInfoPeppol = () => {
        if (!isEmpty(editClient.vatNumber) && String(editClient.vatNumber).length === 9) {
            setLoadingPeppolDetails(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/get-company-info-peppol", {vatNumber: editClient.vatNumber}, {
                headers: {'Content-Type': 'application/json'}
            }).then((res) => {
                setLoadingPeppolDetails(false);
                if (res.data.status === "200") {
                    if (res.data.data && res.data.data?.length > 0) {
                        if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
                        dispatch(setEditClient({...editClient, peppolPartyIdentification: res.data.data}));
                        toast.success("Οι κωδικοί αναθετουσών αρχών συμπληρώθηκαν αυτόματα επιτυχώς.");
                    } else {
                        toast.info("Δεν βρέθηκαν αναθέτουσες αρχές για αυτό το Α.Φ.Μ.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((error) => {
                setLoadingPeppolDetails(false);
                console.log(error);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Παρακαλώ συμπληρώστε Α.Φ.Μ. πρώτα.");
        }
    }

    const handleClickOpenClientMovementsReport = () => {
        dispatch(setClientMovementsSearchByBalance({
            _id: editClient._id,
            clientName: editClient.name
        }));
        dispatch(openClientMovementsReport(TABS_DATA));
    }

    const handleFetchPatientDetails = () => {
        fetchPatientDetails(editClient.amka, company.id).then((res) => {
            if (res.success) {
                const patientData = res.data;
                let prepObj = {
                    name: `${patientData.lastName} ${patientData.firstName}`,
                    address: patientData.address,
                    city: patientData.city,
                    postalCode: patientData.postalCode,
                    sex: patientData.sex.id === "1" ? "male" : "female",
                    birthDate: moment(patientData.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY") || "",
                }
                prepObj.email = patientData.email || "";
                prepObj.phone = patientData.telephone || "";

                dispatch(setEditClient({...editClient, ...prepObj}))
                toast.success("Επιτυχής άντληση δεδομένων από το μητρώο.");
            } else {
                toast.error(res.data);
            }
        })
    }

    const handleOpenPatientHistory = () => {
        dispatch(setAutoPatientHistory(editClient));
        dispatch(openTabByType("patient-history", TABS_DATA));
    }

    const handleOpenManageCompanies = () => {
        const client = editClient;
        const prefilledCompanyData = {
            ...COMPANY_DATA.newCompanyInitialValue,
            name: client.name,
            vatNumber: client.vatNumber,
            activity: client.activity,
            city: client.city,
            postalCode: client.postalCode,
            email: client.email,
            phone: client.phone,
            webpage: client.webpage,
            country: client.country,
            headquartersAddress: client.address,
            doy: getDOYOptions().find(opt => String(opt.value) === String(client.DOY))?.label || "",
            contactPoints: client.contactPoints || [],
            installations: client.installations.length > 0 ? client.installations.map(((item, index) => ({
                no: item.no,
                type: item.type,
                address: item.address,
                city: item.city,
                postalCode: item.postalCode,
                doy: Number(item.DOY),
                isActive: "active",
                phone: client.phone,
                installationMasterId: index
            }))) : []
        };

        dispatch(setNewCompany(prefilledCompanyData));
        dispatch(openTabByType('manage-companies', TABS_DATA));
        dispatch(setActiveModal('new-company'));
    }

    return (
        <div className="new-client-general product-form position-relative">
            {disabledFields && <div className="overlay_w">{t('ClientsGeneralEdit.message')}</div>}
            {!isPrimerConstructor && (
                <Row className="position-relative border-bottom mb-2">
                    <Col xs="12" md="12" className="d-flex align-items-center justify-content-end">
                        <div className="inline-field d-flex align-items-center mb-2 mr-5">
                            {(companyHasPrescription && checkPermission("", permissionsData) && editClient.categoryName === "Patient") && (
                                <Button size={"sm"} className={"mr-2"} onClick={() => handleOpenPatientHistory()}>
                                    Προβολή ιστορικού ασθενή
                                </Button>
                            )}
                            {(isCompanyCreator || isAdmin) && (
                                <Button size={"sm"} className={"mr-2"} onClick={() => handleOpenManageCompanies()}>
                                    Δημιουργία εταιρείας από πελάτη
                                </Button>
                            )}
                            <Button size={"sm"} className={"mr-2"} onClick={() => handleClickOpenClientMovementsReport()}>
                                Προβολή καρτέλας πελάτη
                            </Button>
                            <Input
                                name="productInventoryBalance"
                                label={t('ClientsGeneralEdit.clientBalance')}
                                className="mb-2 w-100"
                                value={(typeof (editClient.balance) !== 'undefined') ? Number(editClient.balance).toFixed(2) : 0}
                                disabled={true}
                            />
                        </div>
                        <div className="inline-field d-flex align-items-center acremd  mb-2">
                            <label htmlFor="client-active"
                                   className="mb-0 mr-2 ">{t('ClientsGeneralEdit.clientActive')}</label>
                            <Checkbox
                                className="mb-2"
                                name="isActive"
                                key={Math.random()}
                                id="client-active"
                                defaultValue={editClient.isActive}
                                value={editClient.isActive === 'active' ? "inactive" : "active"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </div>
                    </Col>
                </Row>
            )}
            {/* First Row */}
            <Row>
                <Col sm='12' md="3" className="showWithOverlay">
                    <Dropdown
                        label={t('ClientsGeneralEdit.category')}
                        required={true}
                        options={clientCategoriesOption}
                        isCLientCategory={true}
                        classes="w-100 mb-2"
                        name="category"
                        key={Math.random()}
                        disabled={isPrimerConstructor}
                        defaultValue={getDefaultOptionByValue(clientCategories, editClient.category, '_id', 'category', '_id')}
                        onChange={(e) => handleOnChange(e, 'dd', 'category')}
                    />
                </Col>
                <Col sm='12' md="3">
                    <Input
                        label={t('ClientsGeneralEdit.systemCode.systemCode')}
                        className="mb-2 w-100"
                        disabled={true}
                        key={Math.random()}
                        name={t('ClientsGeneralEdit.systemCode.placeholder')}
                        defaultValue={editClient.systemCode}
                        placeholder="eg. sc-***"
                    />
                </Col>
                <Col sm='12' md="3">
                    <Input
                        label={t('ClientsGeneralEdit.manualCode.manualCode')}
                        className="mb-2 w-100"
                        name="manualCode"
                        type="text"
                        disabled={isPrimerConstructor}
                        value={editClient.manualCode}
                        placeholder={t('ClientsGeneralEdit.manualCode.placeholder')}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        name={"tags"}
                        label={"Ετικέτες"}
                        multiSelect={true}
                        options={tagOptions}
                        defaultValue={tagOptions.filter((el) => (editClient?.tags || []).includes(el.value))}
                        onChange={(e) => {
                            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
                            dispatch(setEditClient({...editClient, tags: e.map((o) => o.value)}))
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm='12' md="4">
                    <div className="mb-2">
                        <Input
                            label={t('ClientsGeneralEdit.name.name')}
                            required={true}
                            className="w-100"
                            name="name"
                            type="text"
                            disabled={isPrimerConstructor}
                            value={editClient.name}
                            placeholder={t('ClientsGeneralEdit.name.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {showErrors && editClient.name === '' &&
                            <div className="text-danger">{t('ClientsGeneralEdit.name.required')}</div>}
                    </div>
                </Col>
                {editClient.categoryName !== "" &&
                    editClient.categoryName !== "Retail" &&
                    editClient.categoryName !== "Patient" &&
                    <Col sm='12' md="4">
                        <Input
                            label={t('ClientsGeneralEdit.smallName.smallName')}
                            className="mb-2 w-100"
                            name="smallName"
                            type="text"
                            disabled={isPrimerConstructor}
                            value={editClient.smallName}
                            placeholder={t('ClientsGeneralEdit.smallName.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                }
                <Col sm='12' md="4">
                    <div className='mb-2'>
                        <Dropdown
                            label={t('ClientsGeneralEdit.vatCategory.vatCategory')}
                            classes="w-100"
                            required={true}
                            name="vatCategory"
                            disabled={isPrimerConstructor}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(vatCategoryList, editClient.vatCategory, 'value', 'label', 'value')}
                            options={vatCategoryList}
                            onChange={(e) => handleOnChange(e, 'dd', 'vatCategory')}
                        />
                        {showErrors && editClient.vatCategory === '' &&
                            <div className="text-danger">{t('ClientsGeneralEdit.vatCategory.required')}</div>}
                    </div>
                </Col>
                {(editClient.vatCategory !== "" && editClient.vatCategory === 'Zero VAT') && (
                    <Col sm="12" md="4">
                        <div className="mb-2">
                            <Dropdown
                                classes='w-100'
                                label={t('ClientsGeneralEdit.0VatReason.0VatReason')}
                                key={Math.random()}
                                name="vatReason"
                                disabled={isPrimerConstructor}
                                required={true}
                                options={zeroVatReasonOptions}
                                defaultValue={editClient.vatReason ? {
                                    value: editClient.vatReason,
                                    label: getLabelByValue(zeroVatReasonOptions, editClient.vatReason, 'value'),
                                    color: "#76AEB7"
                                } : null}
                                onChange={(e) => handleOnChange(e, 'dd', 'vatReason')}
                            />
                            {showErrors && editClient.vatCategory === 'Zero VAT' && editClient.vatReason === "" && (
                                <div className="text-danger">{t('ClientsGeneralEdit.vatCategory.required')}.</div>
                            )}
                        </div>
                    </Col>
                )}
                {(editClient.vatCategory !== "" && editClient.vatCategory === 'Custom VAT') &&
                    <Col xs="12" md="4">
                        <div className="mb-2">
                            <Input
                                name="customVat"
                                type="number"
                                disabled={isPrimerConstructor}
                                validate={isValidCustomVat}
                                placeholder={t('ClientsGeneralEdit.customVat%.placeholder')}
                                label={t('ClientsGeneralEdit.customVat%.customVat%')}
                                charLimit={3}
                                onChange={(e) => handleOnChange(e)}
                                value={editClient.customVat}
                            />
                            {(editClient.vatCategory === 'Custom VAT' &&
                                    editClient.customVat === "") &&
                                <div className="text-danger">{t('ClientsGeneralEdit.customVat%.required')}</div>
                            }
                        </div>
                    </Col>
                }
            </Row>
            <Row>
                {/* Retail: Add 999999999, do not validate VAT number. Field not mandatory */}
                {/* Client inside E.U.,outside E.U., Do not validate VAT, do not enter anything. Not mandatory field */}
                {(editClient.categoryName === 'Retail' || editClient.categoryName === 'Patient') &&
                    <Col sm={12} md={4}>
                        <Input
                            label={t("General.vatNumber")}
                            className="mb-2 w-100 bg-white"
                            name="vatNumber"
                            type="number"
                            disabled={isPrimerConstructor}
                            value={editClient.vatNumber}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                }
                {/* Freelancer, O.E., E.E., E.P.E., I.K.E., A.E.: Validate VAT number, use "Get Details" button to get company details. Mandatory field */}
                {(
                    editClient.categoryName === 'Freelancer' ||
                    editClient.categoryName === 'O.E.' ||
                    editClient.categoryName === 'E.E.' ||
                    editClient.categoryName === 'E.P.E.' ||
                    editClient.categoryName === 'I.K.E.' ||
                    editClient.categoryName === "Non-Profit Organization" ||
                    editClient.categoryName === 'A.E.' ||
                    editClient.categoryName === 'Wholesale Others' ||
                    editClient.categoryName === "Client within E.U." ||
                    editClient.categoryName === "Client outside E.U." ||
                    editClient.categoryName === "Leads"
                ) && (
                    <Col sm='12' md="4">
                        <div className='mb-2'>
                            <Input
                                label={t('ClientsGeneralEdit.vatNumber.vatNumber')}
                                className="w-100 bg-white"
                                name="vatNumber"
                                required={true}
                                charLimit={15}
                                type={editClient.categoryName === 'Wholesale Others' ||
                                editClient.categoryName === "Client within E.U." ||
                                editClient.categoryName === "Client outside E.U." ? "text" : "number"}
                                value={editClient.vatNumber}
                                placeholder={t('ClientsGeneralEdit.vatNumber.placeholder')}
                                onChange={(e) => handleOnChange(e)}
                                disabled={isPrimerConstructor}
                            />
                            {showErrors && editClient.vatNumber === '' &&
                                <div className="text-danger">{t('ClientsGeneralEdit.vatNumber.required')}</div>}
                        </div>
                    </Col>
                )}

                {/* Show only if category is NOT Retail or Patient */}
                {/* Use "Get Greek Company Details from taxisnet" algorithm */}
                {(editClient.categoryName !== '' &&
                    editClient.categoryName !== 'Retail' &&
                    editClient.categoryName !== 'Patient' &&
                    editClient.categoryName !== "Client within E.U." &&
                    editClient.categoryName !== "Client outside E.U." && !isPrimerConstructor) && (
                    <Col sm='12' md="2" className="d-flex align-items-center">
                        <Button onClick={() => fetchTaxisNetDetails(editClient.vatNumber)} size="sm"
                                className="mb-2" type='button' disabled={loadingTaxis}>
                            {t('ClientsGeneralEdit.getDetails')} {loadingTaxis && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                )}
                {(editClient.categoryName === "Client within E.U." && !isPrimerConstructor) && (
                    <Col sm="12" md="2" className="d-flex align-items-center">
                        <Button
                            onClick={() => fetchViesDetails(editClient.vatNumber, editClient.country)}
                            size="sm"
                            className="mb-2"
                            type="button"
                            disabled={loadingTaxis}
                        >
                            VIES CHECK {loadingTaxis && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                )}
                {(editClient.categoryName === "Freelancer" ||
                    editClient.categoryName === "O.E." ||
                    editClient.categoryName === "E.E." ||
                    editClient.categoryName === "E.P.E." ||
                    editClient.categoryName === "I.K.E." ||
                    editClient.categoryName === "A.E." ||
                    editClient.categoryName === "Non-Profit Organization" ||
                    editClient.categoryName === 'Wholesale Others') && (
                    <Col sm='12' md="3">
                        <Dropdown
                            label={t('ClientsGeneralEdit.doy.doy')}
                            classes="w-100"
                            required={
                                (
                                    editClient.categoryName !== 'Retail' &&
                                    editClient.categoryName !== 'Patient' &&
                                    editClient.categoryName !== 'Client within E.U.' &&
                                    editClient.categoryName !== 'Client outside E.U.'
                                )
                            }
                            disabled={isPrimerConstructor}
                            searchEnable={true}
                            name="DOY"
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(getDOYOptions(), Number(editClient.DOY), 'value', 'label', 'value')}
                            options={getDOYOptions()}
                            onChange={(e) => handleOnChange(e, 'dd', 'DOY')}
                        />
                        {(
                                editClient.categoryName !== 'Retail' &&
                                editClient.categoryName !== 'Patient' &&
                                editClient.categoryName !== 'Client within E.U.' &&
                                editClient.categoryName !== 'Client outside E.U.'
                            ) &&
                            showErrors &&
                            editClient.DOY === '' &&
                            <div className="text-danger">{t('ClientsGeneralEdit.doy.required')}</div>
                        }
                    </Col>)}
                {(editClient.categoryName === "Freelancer" ||
                    editClient.categoryName === "O.E." ||
                    editClient.categoryName === "E.E." ||
                    editClient.categoryName === "E.P.E." ||
                    editClient.categoryName === "I.K.E." ||
                    editClient.categoryName === "A.E." ||
                    editClient.categoryName === "Non-Profit Organization" ||
                    editClient.categoryName === 'Wholesale Others') && (
                    <Col sm='12' md="3">
                        <Input
                            label={t('ClientsGeneralEdit.activity.activity')}
                            className="w-100"
                            name="activity"
                            type="text"
                            charLimit={1000}
                            disabled={isPrimerConstructor}
                            required={
                                editClient.categoryName !== "Retail" &&
                                editClient.categoryName !== "Patient"
                            }
                            value={editClient.activity}
                            placeholder={t('ClientsGeneralEdit.activity.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {editClient.categoryName !== "Retail" &&
                            editClient.categoryName !== "Patient" &&
                            showErrors &&
                            editClient.activity === "" && (
                                <div className="text-danger">{t('ClientsGeneralEdit.activity.required')}</div>
                            )}
                    </Col>
                )}
                {/* show only if Category is "Patient" */}
                {(editClient.categoryName === 'Patient') &&
                    <Col sm='12' md="4">
                        <div className={"mb-2"} style={{display: "flex"}}>
                            <Input
                                label={t('ClientsGeneralEdit.amka.amka')}
                                className="mb-2 w-100"
                                name="amka"
                                type="text"
                                charLimit={30}
                                disabled={isPrimerConstructor}
                                value={editClient.amka}
                                placeholder="Enter AMKA"
                                onChange={(e) => handleOnChange(e)}
                            />
                            {companyHasPrescription && (
                                <Button style={{marginTop: "20px", marginLeft: "10px"}} size={"sm"} onClick={() => handleFetchPatientDetails()}>
                                    Άντληση δεδομένων
                                </Button>
                            )}
                        </div>
                        {showErrors &&
                            editClient.categoryName === "Patient" &&
                            editClient.email === "" &&
                            editClient.amka === "" &&
                            editClient.phone === "" && (
                                <div className="text-danger">{t('ClientsGeneralEdit.amka.required')}</div>
                            )}
                    </Col>
                }
            </Row>
            <Row>
                <Col sm='12' md="3">
                    {/* Mandatory field EXCEPT if category retail & patient */}
                    <Dropdown
                        label={t('ClientsGeneralEdit.country.country')}
                        classes="w-100"
                        required={(editClient.categoryName !== 'Retail' && editClient.categoryName !== 'Patient')}
                        name="country"
                        searchEnable={true}
                        key={Math.random()}
                        disabled={isPrimerConstructor}
                        defaultValue={getDefaultOptionByValue(allCountries, editClient.country, 'value', 'label', 'value')}
                        options={countriesList}
                        onChange={(e) => handleOnChange(e, 'dd', 'country')}
                    />
                    {(editClient.categoryName !== 'Retail' &&
                            editClient.categoryName !== 'Patient') &&
                        showErrors &&
                        editClient.country === '' &&
                        <div className="text-danger">{t('ClientsGeneralEdit.country.required')}</div>
                    }
                </Col>
                <Col sm='12' md="3">
                    <div className='mb-2'>
                        {/* Mandatory field EXCEPT if category retail & patient */}
                        <Input
                            label={t('ClientsGeneralEdit.address.address')}
                            className="w-100"
                            name="address"
                            type="text"
                            charLimit={100}
                            disabled={isPrimerConstructor}
                            required={(editClient.categoryName !== 'Retail')}
                            value={editClient.address}
                            placeholder={t('ClientsGeneralEdit.address.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {(editClient.categoryName !== 'Retail') &&
                            showErrors &&
                            editClient.address === '' &&
                            <div className="text-danger">{t('ClientsGeneralEdit.address.required')}</div>
                        }
                    </div>
                </Col>
                <Col sm='12' md="3">
                    <div className='mb-2'>
                        {/* Mandatory field EXCEPT if category retail & patient */}
                        <Input
                            label={t('ClientsGeneralEdit.city.city')}
                            className="w-100"
                            name="city"
                            type="text"
                            charLimit={100}
                            disabled={isPrimerConstructor}
                            required={
                                editClient.categoryName !== "Retail" &&
                                editClient.categoryName !== "Patient"
                            }
                            value={editClient.city}
                            placeholder={t('ClientsGeneralEdit.city.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {editClient.categoryName !== "Retail" &&
                            editClient.categoryName !== "Patient" &&
                            showErrors &&
                            editClient.city === "" && (
                                <div className="text-danger">{t('ClientsGeneralEdit.city.required')}</div>
                            )}
                    </div>
                </Col>
                <Col sm='12' md="3">
                    {/* Mandatory field EXCEPT if category retail & patient */}
                    <div className='mb-2'>
                        <Input
                            label={t('ClientsGeneralEdit.postalCode.postalCode')}
                            className="w-100"
                            name="postalCode"
                            type="text"
                            disabled={isPrimerConstructor}
                            required={(editClient.categoryName !== 'Retail' && editClient.categoryName !== 'Patient')}
                            value={editClient.postalCode}
                            placeholder={t('ClientsGeneralEdit.postalCode.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {(editClient.categoryName !== 'Retail' &&
                                editClient.categoryName !== 'Patient') &&
                            showErrors &&
                            editClient.postalCode === '' &&
                            <div className="text-danger">{t('ClientsGeneralEdit.postalCode.required')}</div>
                        }
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm='12' md="3">
                    <div className='mb-2'>
                        <Input
                            label={t('ClientsGeneralEdit.email.email')}
                            className="w-100"
                            name="email"
                            type="email"
                            disabled={isPrimerConstructor}
                            value={editClient.email}
                            placeholder={t('ClientsGeneralEdit.email.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                            required={editClient.phone === ''}
                        />
                        {showErrors &&
                            editClient.email !== '' && !isValidEmail(editClient.email) &&
                            <div className="text-danger">{t('ClientsGeneralEdit.email.error')}</div>
                        }

                        {showErrors &&
                            editClient.categoryName !== "Patient" &&
                            editClient.categoryName !== "I.K.E." &&
                            editClient.categoryName !== "Freelancer" &&
                            editClient.categoryName !== "O.E." &&
                            editClient.categoryName !== "E.E." &&
                            editClient.categoryName !== "A.E." &&
                            editClient.categoryName !== "Non-Profit Organization" &&
                            editClient.categoryName !== "E.P.E." &&
                            editClient.categoryName !== "Wholesale Others" &&
                            editClient.email === "" &&
                            editClient.phone === "" && (
                                <div className="text-danger">{t('ClientsNewGeneral.email.required')}</div>
                            )}
                        {showErrors &&
                            editClient.categoryName === "Patient" &&
                            editClient.email === "" &&
                            editClient.amka === "" &&
                            editClient.phone === "" && (
                                <div className="text-danger">{t('ClientsGeneralEdit.email.required')}</div>
                            )}
                    </div>
                </Col>
                <Col sm='12' md="3">
                    <Input
                        label={t('ClientsGeneralEdit.phone.phone')}
                        className="mb-2 w-100"
                        name="phone"
                        type="tel"
                        disabled={isPrimerConstructor}
                        charLimit={20}
                        value={editClient.phone}
                        placeholder={t('ClientsGeneralEdit.phone.placeholder')}
                        onChange={(e) => handleOnChange(e)}
                        required={editClient.email === ''}
                        allowTelephoneDial={true}
                    />
                </Col>
                <Col sm='12' md="3">
                    <Input
                        label={t('ClientsGeneralEdit.gemh.gemh')}
                        className="mb-2 w-100"
                        name="gemhNo"
                        type="text"
                        disabled={isPrimerConstructor}
                        value={editClient.gemhNo}
                        placeholder={t('ClientsGeneralEdit.phone.placeholder')}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col sm='12' md="3">
                    <Input
                        label={t('ClientsGeneralEdit.webpage.webpage')}
                        className="mb-2 w-100"
                        name="webpage"
                        type="url"
                        disabled={isPrimerConstructor}
                        value={editClient.webpage}
                        placeholder={t('ClientsGeneralEdit.webpage.placeholder')}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            {(checkPermission("custom-b2g", permissionsData) && !["Retail", "Patient", "Client within E.U.", "Client outside E.U."].includes(editClient.categoryName)) && (
                <Row>
                    <Col md={5}>
                        <div className={"text-muted mb-1"}><i>Πληροφορίες για Δημόσιες Συμβάσεις</i></div>
                        <Button size={"sm"} className={"mr-3"} onClick={() => handleGetCompanyInfoPeppol()}
                                disabled={loadingPeppolDetails}>
                            Ανάκτηση Αναθετουσών από Α.Φ.Μ.
                            {loadingPeppolDetails &&
                                <Spinner className={"ml-3"} size={"sm"} animation="border" variant="dark"/>}
                        </Button>
                        <AnathetousesModal data={editClient}/>
                    </Col>
                </Row>
            )}
            {editClient.categoryName === "Patient" && (
                <Row>
                    <Col md={3}>
                        <Dropdown
                            label={"Φύλο"}
                            name={"sex"}
                            options={getSexOptions()}
                            key={Math.random()}
                            defaultValue={getSexOptions().find((el) => el.value === editClient.sex)}
                            onChange={(e) => handleOnChange(e, "dd", "sex")}
                        />
                    </Col>
                    <Col md={3}>
                        <DateBox
                            name={"birthDate"}
                            label={"Ημερομηνία Γέννησης"}
                            allowOtherYears={true}
                            selected={moment(editClient.birthDate, "DD/MM/YYYY").isValid() ? moment(editClient.birthDate, "DD/MM/YYYY").toDate() : null}
                            onChange={(e) => handleOnChange(e, "datebox", "birthDate")}
                            minDate={new Date("01-01-1850")}
                        />
                    </Col>
                </Row>
            )}
            {(["801866110", "800566476"].includes(company.vatNumber)) && (
                <React.Fragment>
                    <Row className="mt-2">
                        <Col md={4}>
                            <Input
                                label={t('ClientsGeneralEdit.representativeName.representativeName')}
                                className="mb-2 w-100"
                                name={"representativeName"}
                                type={"text"}
                                placeholder={t('ClientsGeneralEdit.representativeName.placeholder')}
                                value={editClient.representativeName}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.representativeEditable !== true || isPrimerConstructor}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                label={t('ClientsGeneralEdit.representativeSurname.representativeSurname')}
                                className="mb-2 w-100"
                                name={"representativeSurname"}
                                type={"text"}
                                placeholder={t('ClientsGeneralEdit.representativeSurname.placeholder')}
                                value={editClient.representativeSurname}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.representativeEditable !== true || isPrimerConstructor}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                label={t('ClientsGeneralEdit.representativeVatNumber.representativeVatNumber')}
                                className="mb-2 w-100"
                                name={"representativeVatNumber"}
                                type={"text"}
                                placeholder={t('ClientsGeneralEdit.representativeVatNumber.placeholder')}
                                value={editClient.representativeVatNumber}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.representativeEditable !== true || isPrimerConstructor}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <Input
                                label={"Όνομα Παρόχου ISP"}
                                className="mb-2 w-100"
                                name={"simProvider"}
                                type={"text"}
                                autoComplete={"off"}
                                value={editClient.simProvider}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.simProvider !== true || isPrimerConstructor}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                label={"Αριθμός σύμβασης ISP"}
                                className="mb-2 w-100"
                                name={"simContractId"}
                                type={"text"}
                                autoComplete={"off"}
                                value={editClient.simContractId}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.simContractEditable !== true || isPrimerConstructor}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                label={"Ημερομηνία σύμβασης με ISP (DD/MM/YYYY)"}
                                className="mb-2 w-100"
                                name={"simContractDate"}
                                type={"text"}
                                autoComplete={"off"}
                                value={editClient.simContractDate}
                                onChange={(e) => handleOnChange(e)}
                                disabled={editClient?.simContractEditable !== true || isPrimerConstructor}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
            {!isPrimerConstructor && (
                <React.Fragment>
                    <hr/>
                    <p className="text-muted"><i>{t('ClientsGeneralEdit.table.title')}</i></p>
                    <EditableTable
                        tableName="Edit Client Contact Points"
                        key={"Edit Client Contact Points" + incrKey}
                        allowActions={true}
                        allowToggleColumns={true}
                        toggleColumns={handleColumnShowHide}
                        columns={tableColumns}
                        data={editClient.contactPoints}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={parentMydataActions}
                    />
                    <p className="text-muted"><i>{t('ClientsGeneralEdit.bankInfoTable.title')}</i></p>
                    <EditableTable
                        tableName="Edit Client Bank Info"
                        key={"Edit Client Bank Info" + bankInfoIncrKey}
                        allowActions={true}
                        columns={bankInfoTableColumns}
                        data={editClient.bankInfo}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={bankInfoTableActions}
                    />

                    <p><i>{t('ClientsGeneralEdit.clientNotes.clientNotes')}</i></p>
                    <TextArea
                        className="mb-2"
                        rows="4"
                        placeholder={t('ClientsGeneralEdit.clientNotes.placeholder')}
                        name="clientNotes"
                        value={editClient.clientNotes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </React.Fragment>
            )}
        </div>
    )
}

export const ClientsEditLog = ({tabKey}) => {
    const {t} = useTranslation();
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.clientLog')}</i></div>
            <LogTable itemId={editClient._id}/>
        </React.Fragment>
    )
}

export default EditClientGeneral;
